export default __webpack_public_path__ + "static/instagram-c91566c5ea583aa46b3289b2455f059c.png";